/* hs-eslint ignored failing-rules */

import ArticlesApi from '../../api/Articles';
import * as ActionTypes from '../ActionTypes';
import { showErrorNotification } from '../Notifications';
function authorsReceived(payload) {
  return {
    type: ActionTypes.FETCH_AUTHORS_SUCCESS,
    payload
  };
}
function authorsRequesting() {
  return {
    type: ActionTypes.FETCH_AUTHORS_PENDING
  };
}
function authorsRequestFailed(error) {
  return {
    error,
    type: ActionTypes.FETCH_AUTHORS_ERROR
  };
}
export function getAuthors(knowledgeBaseId) {
  return dispatch => {
    dispatch(authorsRequesting());
    ArticlesApi.getAuthors(knowledgeBaseId).then(response => dispatch(authorsReceived(response)), error => {
      dispatch(showErrorNotification('getAuthors'));
      dispatch(authorsRequestFailed(error));
    }).catch(error => {
      dispatch(showErrorNotification('getAuthors'));
      dispatch(authorsRequestFailed(error));
    });
  };
}